import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustItems = [
    {
      icon: 'Shield',
      text: 'SSL Güvenli Bağlantı'
    },
    {
      icon: 'Lock',
      text: 'KVKK Uyumlu'
    },
    {
      icon: 'CheckCircle',
      text: '5000+ Aktif Kullanıcı'
    }
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 lg:gap-8 py-4 md:py-5 lg:py-6">
      {trustItems?.map((item, index) => (
        <div key={index} className="flex items-center gap-2">
          <Icon name={item?.icon} size={16} color="var(--color-success)" />
          <span className="text-xs md:text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
            {item?.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TrustSignals;